module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ctn-link row"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'Cgu'
      }
    }
  }, [_vm._v("Conditions générales d'utilisation")]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "#"
    }
  }, [_vm._v("Conditions générales de vente")]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'Legals'
      }
    }
  }, [_vm._v("Mentions légales")]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'Confidentiality'
      }
    }
  }, [_vm._v("Politique de confidentialité")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t© " + _vm._s(_vm.year) + " Patrimoffice. Tous droits réservés.\n\t\t")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-480ac766"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/footer.vue
// module id = 1118
// module chunks = 0